<template>
  <div class="menu-item">
    <BizIcon
      v-if="item.icon"
      :type="`${item.icon}`"
      style="margin-right: 11px"
    />
    <div class="menu-item-text">{{ item.name }}</div>
  </div>
</template>
<script>
import BizIcon from '@/components/BizIcon';

export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  components: {
    BizIcon,
  },
};
</script>

<style lang="scss" scoped>
.menu-item {
  .menu-item-text {
    padding: 5px 17px;
    border-radius: 4px;
    margin-left: -17px;
    line-height: 22px;
  }
}
</style>

<style lang="scss">
.antmain-menu-item-selected  .menu-item-text {
  background: fade-out(#000, 0.96);
  color: #333;
  font-weight: 500;
}
</style>
